import { render, staticRenderFns } from "./BubbleMenu.vue?vue&type=template&id=d228d170&scoped=true"
import script from "./BubbleMenu.vue?vue&type=script&lang=js"
export * from "./BubbleMenu.vue?vue&type=script&lang=js"
import style0 from "./BubbleMenu.vue?vue&type=style&index=0&id=d228d170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d228d170",
  null
  
)

export default component.exports